import { render } from "./ScrollPanaroma.vue?vue&type=template&id=b6b179e8"
import script from "./ScrollPanaroma.vue?vue&type=script&lang=js"
export * from "./ScrollPanaroma.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__